import React from 'react';

export default function LayoutBackToTop() {
	const goTop = () => window.scrollTo(0, 0);

	return (
		<div id='back-to-top'>
			<div className='pointer' onClick={goTop}>
				<i className='fa fa-angle-up' />
			</div>
		</div>
	);
}
